import gql from 'graphql-tag'

export const GET_DEVICE_CODE = gql`
  query Devices {
    deviceTypes {
      isSuccessful
      message
      deviceType {
        deviceCode
        deviceName
      }
    }
  }
`

export const GET_DEVICE = gql`
  query Device($filter: GetDeviceInput!) {
    device(filter: $filter) {
      isSuccessful
      message
      device {
        vehicleId
        portKernel
        phoneNo
        imei
        deviceName
        deviceCode
        companyId
      }
    }
  }
`

// getTracking
export const GET_DEVICES = gql`
  query Devices($filter: GetDevicesFilter) {
    devices(filter: $filter) {
      isSuccessful
      message
      devices {
        imei
        identifier
        companyId
        vehicleId
        phoneNo
        ip
        port
        deviceCode
        deviceName
        vendorType
        portKernel
        activeOn
        status
        domain
        database
        username
        password
      }
    }
  }
`

// getAllTracking
// query VehicleStatuses($filter: GetQcDevicesFilter) {
//   vehicleStatuses(filter: $filter) {
export const GET_QC_DEVICES = gql`
  query VehicleStatuses {
    vehicleStatuses {
      isSuccessful
      message
      vehicleStatuses {
        companyId
        ip
        port
        lastReceive
        speed
        latitude
        longitude
        signalStrength
        battery
        licensePlate
        lastPacket
        vehicleId
        vehicle {
          imei
          status
          device {
            portKernel
            vendorType
            deviceName
            deviceCode
            portKernel
            phoneNo
          }
        }
      }
    }
  }
`

export const DEVICE_CREATE = gql`
  mutation CreateDevice($input: CreateDeviceInput!) {
    createDevice(input: $input) {
      isSuccessful
      message
      device {
        imei
        identifier
        companyId
        phoneNo
        deviceCode
        deviceName
        vendorType
        portKernel
      }
    }
  }
`

export const DEVICE_UPDATE = gql`
  mutation UpdateDevice($input: UpdateDeviceInput!) {
    updateDevice(input: $input) {
      isSuccessful
      message
      device {
        vehicleId
        activeOn
        imei
      }
    }
  }
`

export const DEVICE_MUTATION_CREATE = gql`
  mutation CreateDevice($input: CreateDeviceInput!) {
    createDevice(input: $input) {
      isSuccessful
      message
      device {
        imei
        identifier
        companyId
        vehicleId
        phoneNo
        ip
        port
        deviceCode
        deviceName
        vendorCode
        vendorName
        portKernel
        activeOn
        status
        domain
        database
        username
        password
      }
    }
  }
`

export const DEVICE_MUTATION_UPDATE = gql`
  mutation UpdateDevice($input: UpdateDeviceInput!) {
    updateDevice(input: $input) {
      isSuccessful
      message
      device {
        imei
        identifier
        companyId
        vehicleId
        phoneNo
        ip
        port
        deviceCode
        deviceName
        vendorType
        portKernel
        activeOn
        status
        domain
        database
        username
        password
      }
    }
  }
`

export const DEVICE_MUTATION_DELETE = gql`
  mutation UpdateDevice($imei: String!) {
    updateDevice(imei: $imei, data: { status: 2 }) {
      isSuccessful
      message
      device {
        imei
        identifier
        companyId
        vehicleId
        phoneNo
        ip
        port
        deviceCode
        deviceName
        vendorCode
        vendorName
        portKernel
        activeOn
        status
        domain
        database
        username
        password
      }
    }
  }
`
